/* eslint-disable react/prop-types */
import classes from "./card-view-list-step-three.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";

function CardViewListStepThree({ item }) {
  return (
    <Flex
      align="center"
      direction="column"
      justify="flex-start"
      className={classes.container}
    >
      <img
        src="/images/software/PROSSIMITI-icon-Check.svg"
        alt="Logo"
        className={classes.icon}
      />
      <Label align="center" size="md" color="secondary">
        {item.content}
      </Label>
    </Flex>
  );
}

export default CardViewListStepThree;
